
/**
 * The key will be injected as a prop on the component with the translated text as value
 *
 * Example:
 *
 * React component will recive `props.translation` where
 *
 * `translation.edit: 'Edit' `
 */
export const caseTranslations = {
  message_cannot_find_case_draft: 7441,
  message_draft_success: 7442,
  message_case_success: 7440,
  message_case_delete_success: 7472,
  message_case_error: 7439,
  message_not_authorized_to_read_case: 3276,
  case_menu: 7969,
  switch_to_tab: 7978,
  switch_to_scroll: 7977,
  public_case_submitted: 8245,
  public_follow_up: 8246,
  public_info_case_password: 8247,
  public_enter_password: 8248,
  public_case_password: 8249,
  public_open_case: 8250
};

export const viewModeCacheKey:string = 'caseViewMode';
